import { ZodString } from "zod";

export const flightNumberRegexp = /[1-9]\d{0,3}[a-z]?/;

export function isValidFlightNumber(schema: ZodString) {
  return schema.refine(
    (value) => {
      return flightNumberRegexp.test(value);
    },
    { message: "validation.flight_number.invalid" },
  );
}
